import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess107115Status: 'idle',
    startProcess107115Error: undefined as any,
    loadUserParamsProcess107115Status: 'idle',
    loadUserParamsProcess107115Error: undefined as any,

    process107115List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess107115 = createAsyncThunk('process107115Slice/startProcess107115', async ({ process107115 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess107115/`,
        prepareData(process107115),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess107115Status } = getState().process107115Slice
        return startProcess107115Status !== 'pending'
    }
})

export const loadUserParamsProcess107115 = createAsyncThunk('process107115Slice/loadUserParamsProcess107115', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess107115/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess107115Status } = getState().process107115Slice
        return loadUserParamsProcess107115Status !== 'pending'
    }
})

const Process107115Slice = createSlice({
    name: 'process107115Slice',
    initialState,
    reducers: {
        resetstartProcess107115: (state) => {
            state.job = undefined
            state.startProcess107115Error = undefined
        },
        resetstartProcess107115Error: (state) => {
            state.startProcess107115Error = undefined
        },
        resetloadUserParamsProcess107115: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess107115Error = undefined
        },
        resetloadUserParamsProcess107115Error: (state) => {
            state.loadUserParamsProcess107115Error = undefined
        },
        removeFromProcess107115ListById: (state, action) => {
            state.process107115List = state.process107115List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess107115ListByIds: (state, action) => {
            state.process107115List = state.process107115List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process107115List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess107115Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process107115List = []
            state.startProcess107115Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess107115.pending, (state) => {
            state.startProcess107115Status = 'pending'
            state.startProcess107115Error = undefined
        })
        builder.addCase(startProcess107115.fulfilled, (state, action) => {
            state.startProcess107115Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess107115.rejected, (state, action) => {
            state.startProcess107115Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess107115Error = action.error.message
            } else {
                state.startProcess107115Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess107115.pending, (state) => {
            state.loadUserParamsProcess107115Status = 'pending'
            state.loadUserParamsProcess107115Error = undefined
        })
        builder.addCase(loadUserParamsProcess107115.fulfilled, (state, action) => {
            state.loadUserParamsProcess107115Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess107115.rejected, (state, action) => {
            state.loadUserParamsProcess107115Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess107115Error = action.error.message
            } else {
                state.loadUserParamsProcess107115Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess107115,
    resetstartProcess107115Error,
    resetloadUserParamsProcess107115,
    resetloadUserParamsProcess107115Error,
    removeFromProcess107115ListById,
    removeFromProcess107115ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process107115Slice.actions
export default Process107115Slice.reducer
